<template>

    <div class="row">
        <div class="col-12 col-md-12">
            <div class="modal-content"
                 style="border-top: 1px solid lightgray;">
                <div v-if="selectedLanguage == 'en'"
                     class="modal-body">
                    <ol>
                        <li>This benefit is exclusive to Centurion Primary &amp; one supplementary Cardmembers holding
                            Centurion Cards issued by American Express Saudi Arabia.</li>
                        <li>This benefit applies to individuals.</li>
                        <li>As a Centurion Primary Cardmember, Enjoy two complimentary annual Priority Pass memberships
                            with unlimited access—one for you as the primary cardmember and one for the Centurion
                            supplementary cardholder of your choice.</li>
                        <li>For any additional guest, a charge of SAR 135.19&circledcirc; (equivalent to US$ 36.05) per guest applies; this charge will be debited
                            from the Centurion Card provided at the time of enrollment.</li>
                        <li>Please note that physical membership cards are no longer in production and have been
                            discontinued.</li>
                        <li>The Centurion card cannot be used as a method of access or proof of membership to Priority
                            Pass airport lounges. To access the participating lounges, you must be enrolled in the
                            Priority Pass membership and use your digital membership with the QR code provided.</li>
                        <li>Benefits and lounge fees are subject to change at any time.</li>
                        <li>Lounge access is subject to availability, capacity restrictions, and the individual terms
                            and conditions of each lounge, which may include limitations on the number of guests, dress
                            codes, and behavior policies. Cardmembers must adhere to these rules for entry. American
                            Express Saudi Arabia and Priority Pass are not responsible for denied entry due to such
                            limitations.</li>
                        <li>Children’s access policies, including age restrictions and fees, vary by lounge and are
                            determined solely by the individual lounge. American Express Saudi Arabia and Priority Pass
                            are not responsible for any inconvenience caused by these policies. Please refer to the
                            specific lounge's terms on the Priority Pass website.</li>
                        <li>All additional charges related to extra visits or guests will be charged to Centurion card
                            number provided upon enrollment. If the provided card number has changed in terms of number
                            or expiry date, you must update the new card details by logging into your Priority Pass
                            online account via the Priority Pass website or application. Failure to update these details
                            may result in multiple declines, and your membership will be subject to suspension.
                            Reactivation can only be done by contacting the Priority Pass Team directly.</li>
                        <li>American Express Saudi Arabia is solely responsible for facilitating Priority Pass
                            membership for eligible cardmembers; lounge access and services are the responsibility of
                            Priority Pass and the respective lounges.</li>
                        <li>Misuse of Priority Pass membership, including unauthorized sharing of QR codes or fraudulent
                            use, may result in the suspension or cancellation of benefits.</li>
                        <li>American Express Saudi Arabia and Priority Pass are not liable for any disputes, damages, or
                            inconvenience arising from lounge access or services provided by participating lounges.</li>
                        <li>Priority Pass benefits are provided subject to the Terms and Conditions of Priority Pass.
                            These benefits are separate from American Express Saudi Arabia terms and conditions.</li>
                        <li>Any disputes regarding Priority Pass services must be resolved directly with Priority Pass.
                        </li>
                        <li>American Express Saudi Arabia and Priority Pass are not responsible for any issues caused by
                            system outages, technical failures, or inconvenience resulting from lounge renovations,
                            closures, or unforeseen circumstances beyond their control.</li>
                        <li>Terms and Conditions of American Express Saudi Arabia apply. To view all card benefits,
                            terms, conditions, and fees, please visit American Express Saudi Arabia's website.</li>
                        <li>Terms and Conditions of Priority Pass apply. To view all terms and conditions and fees,
                            please visit the Priority Pass website.</li>
                        <li>Copyright American Express Saudi Arabia all rights are reserved.</li>
                        <li>If you have any feedback or concerns, please contact our Customer Care Team via email: <span
                                  class="wrdbrk"><a
                                   href="mailto:complaints@americanexpress.com.sa">complaints@americanexpress.com.sa</a></span>
                            or call <a href="tel:8004424442">8004424442</a> from inside Saudi Arabia or <a
                               href="tel:+966112926663">+966112926663</a> from outside Saudi Arabia. For more details,
                            please visit the Complaint/Feedback Handling Procedures page on American Express Saudi
                            Arabia's website.</li>
                        <li>For more information, please contact us on <a href="tel:8001225225">8001225225</a> (from
                            inside Saudi Arabia) or <a href="tel:(+966) 11 407 1999">(+966) 11 407 1999</a> (from
                            outside Saudi Arabia), or visit American Express Saudi Arabia's website.</li>
                        <li style="color: red;">Non-compliance with the Terms &amp; Conditions of American Express Saudi
                            Arabia's credit and charge Cards may result in cancellation /suspension of your
                            Card/Additional Cards and a negative impact on your credit bureau record. Minimum payments
                            on your credit card may result in additional charges and fees due to the application of the
                            Murabaha margin to the outstanding balance.</li>
                        <li>American Express Saudi Arabia is regulated and supervised by the Saudi Central Bank.</li>
                    </ol>
                </div>
                <div v-if="selectedLanguage == 'ar'"
                     class="modal-body">
                    <ol>
                        <li>هذه الميزة حصرية للأعضاء الأساسيين لبطاقة سنتشوريون وعضو إضافي واحد فقط، ممن صدرت لهم بطاقة
                            سنتشوريون من أمريكان إكسبريس السعودية.</li>
                        <li>تطبق هذه الميزة على الأفراد.</li>
                        <li>كعضو بطاقة سنتشوريون أساسي، استمتع بعضويتين مجانيتين في برنامج Priority Pass سنويًا تشملان
                            دخولًا غير محدود إلى صالات الانتظار—واحدة لك بصفتك العضو الأساسي، وواحدة لعضو البطاقة
                            الإضافية الذي تختاره.</li>
                        <li>عند اصطحاب أي ضيف إضافي، يتم تطبيق رسوم قدرها 135.19 ريال سعودي① (ما يعادل 36.05 دولارًا أمريكيًا) لكل ضيف. سيتم خصم هذه
                            الرسوم من بطاقتك السنتشوريون المستخدمة عند التسجيل.</li>
                        <li>يرجى العلم أن بطاقات العضوية المطبوعة التي تُستخدم يدويًا لم تعد تُنتج وتم إيقافها.</li>
                        <li>لا يمكن استخدام بطاقة أمريكان إكسبريس البلاتينية كوسيلة للدخول أو كدليل على العضوية في صالات
                            Priority Pass بالمطارات. للدخول إلى الصالات المشاركة، يجب أن تكون مسجلاً في عضوية Priority
                            Pass واستخدام عضويتك الرقمية مع رمز QR المخصص.</li>
                        <li>تخضع المزايا ورسوم الصالات للتغيير في أي وقت دون إشعار مسبق.</li>
                        <li>الدخول إلى الصالات يعتمد على التوافر وحدود الطاقة الاستيعابية، ويخضع لشروط وأحكام كل صالة،
                            والتي قد تشمل قيودًا على عدد الضيوف أو قواعد اللباس أو سياسات السلوك. يجب على الأعضاء
                            الالتزام بهذه القواعد للدخول. لا تتحمل أمريكان إكسبريس السعودية أو Priority Pass أي مسؤولية
                            عن رفض الدخول بسبب هذه القيود.</li>
                        <li>تختلف سياسات دخول الأطفال، بما في ذلك قيود العمر والرسوم، من صالة إلى أخرى ويتم تحديدها بشكل
                            حصري من قبل كل صالة. لا تتحمل أمريكان إكسبريس السعودية أو Priority Pass أي مسؤولية عن أي
                            إزعاج ناتج عن هذه السياسات. يُرجى الاطلاع على شروط وأحكام الصالة المحددة على موقع Priority
                            Pass الإلكتروني.</li>
                        <li>جميع الرسوم الإضافية المتعلقة بالزيارات الإضافية أو الضيوف سيتم خصمها من رقم بطاقتك
                            السنتشوريون التي تم استخدامها عند التسجيل. في حال تغير رقم البطاقة أو تاريخ انتهائها، يجب
                            تحديث تفاصيل البطاقة الجديدة من خلال تسجيل الدخول إلى حساب Priority Pass الخاص بك عبر موقع
                            Priority Pass الإلكتروني أو التطبيق. قد يؤدي عدم تحديث هذه التفاصيل إلى رفض عدة عمليات، مما
                            يعرض عضويتك للتعليق. يمكن إعادة تفعيل العضوية فقط من خلال التواصل مباشرة مع فريق Priority
                            Pass.</li>
                        <li>تقتصر مسؤولية أمريكان إكسبريس السعودية على تسهيل عضوية Priority Pass لأعضاء البطاقات
                            المؤهلين؛ أما خدمات الدخول إلى الصالات والخدمات المقدمة فتقع ضمن مسؤولية Priority Pass
                            والصالات المعنية.</li>
                        <li>يُعتبر إساءة استخدام عضوية Priority Pass، بما في ذلك مشاركة رموز QR غير المصرح بها أو
                            الاستخدام الاحتيالي، سببًا لتعليق أو إلغاء العضوية.</li>
                        <li>لا تتحمل أمريكان إكسبريس السعودية أو Priority Pass أي مسؤولية قانونية أو تعويضية عن أي
                            نزاعات أو أضرار أو إزعاج ينشأ عن استخدام الصالات أو الخدمات المقدمة من قبل الصالات المشاركة.
                        </li>
                        <li>تُقدم مزايا Priority Pass وفقًا لشروط وأحكام Priority Pass. هذه المزايا منفصلة عن شروط
                            وأحكام أمريكان إكسبريس السعودية.</li>
                        <li>يجب تسوية أي نزاعات تتعلق بخدمات Priority Pass مباشرة مع Priority Pass.</li>
                        <li>لا تتحمل أمريكان إكسبريس السعودية أو Priority Pass أي مسؤولية عن المشكلات الناجمة عن انقطاع
                            النظام، أو الأعطال الفنية، أو أي إزعاج نتيجة تجديدات الصالات، أو الإغلاقات، أو أي ظروف غير
                            متوقعة خارجة عن سيطرتهم.</li>
                        <li>تطبق شروط وأحكام أمريكان إكسبريس السعودية. للاطلاع على جميع مزايا البطاقة، الشروط والأحكام
                            والرسوم، الرجاء زيارة موقع أمريكان إكسبريس السعودية.</li>
                        <li>تطبق شروط وأحكام Priority Pass. للاطلاع على جميع الشروط والأحكام والرسوم، الرجاء زيارة
                            Priority Pass.</li>
                        <li>جميع حقوق الطبع والنشر محفوظة لصالح شركة أمريكان إكسبريس السعودية.</li>
                        <li>إذا كان لديك أي شكوى أو ملاحظات، يرجى الاتصال بفريق خدمة العناية بالعملاء عبر البريد
                            الإلكتروني: <span class="wrdbrk"><a
                                   href="mailto:complaints@americanexpress.com.sa">complaints@americanexpress.com.sa</a></span>
                            أو بالاتصال من داخل السعودية على <span class="en-ar"><a
                                   href="tel:8004424442">8004424442</a></span> ومن خارج السعودية <span class="en-ar"><a
                                   href="tel:+966112926663">+966112926663</a></span> ولمزيد من المعلومات الرجاء زيارة
                            صفحة إجراءات الشكاوى والمقترحات على موقع أمريكان إكسبريس السعودية.</li>
                        <li>لمزيد من المعلومات، يرجى التواصل معنا عبر الرقم <span class="en-ar"><a
                                   href="tel:8001225225">8001225225</a></span> (من داخل المملكة العربية السعودية) أو
                            <span class="en-ar"><a href="tel:+ 966 11 407 1999">+ 966 11 407 1999</a></span> (من خارج
                            المملكة العربية السعودية)، أو زيارة موقع أمريكان إكسبريس السعودية.</li>
                        <li style="color: red;">عدم الالتزام بأحكام وشروط إتفاقية البطاقات الائتمانية والإعتمادية من
                            أمريكان إكسبريس السعودية قد يؤدي إلى إلغاء/تعليق بطاقتك أو البطاقات الإضافية، والتأثير سلباً
                            على سجل الائتمان الخاص بك. إن سداد الحد الأدنى من المبلغ المطلوب على بطاقتك الائتمانية قد
                            يؤدي إلى فرض رسوم إضافية نتيجة لتطبيق هامش المرابحة على الرصيد المستحق.</li>
                        <li>ﺗﺨﻀﻊ ﺷﺮﻛﺔ أﻣﺮﻳﻜﺎن إﻛﺴﺒﺮﻳﺲ اﻟﺴﻌﻮدﻳﺔ ﻟﺮﻗﺎﺑﺔ وإﺷﺮاف اﻟﺒﻨﻚ اﻟﻤﺮﻛﺰي اﻟﺴﻌﻮدي.</li>
                    </ol>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import store from '@/store';

export default {
    components: {
    },
    data: () => ({
        selectedLanguage: 'en'
    }),
    created()
    {
        this.unsubscribe = store.subscribe((mutation) =>
        {
            if (mutation.type === 'accounts/SET_LANGUAGE')
            {
                this.selectedLanguage = mutation.payload;
            }
        })
    },
    destroyed()
    {
        this.unsubscribe();
    },
    mounted()
    {
        let lang = localStorage.getItem('language');
        if (lang)
        {
            this.selectedLanguage = localStorage.getItem('language');
        }
        // this.loggedOffers();
    },
    methods: {}
}
</script>
<style scoped>
.modal-content {
    background-image: url("../../assets/images/centurion/carousel-bg.png");
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 1rem;
    padding-bottom: 235px;
    color: black;
    font-size: 14px;
    line-height: 1.5;
}
</style>
